<template>
    <header>
        <!-- <h1>Medical and<br/>Health Sciences</h1> -->
    </header>
    <section class="main">
        <h2>Pacific Health Wayfinders Registration</h2>
        <template v-if="submissionError">
            <h3 class="info">Sorry, an error occured. {{submissionError}}</h3>
        </template>
        <template v-else-if="submittedOk">
            <h3 class="info">Thank you for your submission. The team will be in touch soon.<br/>You can close this browser tab now.</h3>
        </template>
        <tabbed-panel v-else tabstr="About,S1,S2,S3,S4,S5">
            <template v-slot:About><About/></template>
            <template v-slot:S1><s1 ref="r1"/></template>
            <template v-slot:S2><s2 ref="r2"/></template>
            <template v-slot:S3><s3 ref="r3"/></template>
            <template v-slot:S4><s4 ref="r4"/></template>
            <template v-slot:S5><s5 ref="r5"/></template>
        </tabbed-panel>
    </section>
    <div id="blanket"></div>
</template>

<script>
import About from './components/about.vue'
import s1 from './components/section1.vue'
import s2 from './components/section2.vue'
import s3 from './components/section3.vue'
import s4 from './components/section4.vue'
import s5 from './components/section5.vue'
import TabbedPanel from './components/tabbed-panel.vue'

export default {
    name: 'App',
    components: {
    About,s1,s2,s3,s4,s5,TabbedPanel
    },
    data: function (){return {
        submittedOk:false,
        submissionError:""
    }},
}
</script>
